module.exports = __webpack_public_path__ + "static/media/vitalCreditMobile2.5aa474f0.png";